<template>
  <v-container>
    <div id="headersFornedores">
      <div
        v-if="loading"
        :style="styleObject"
        class="text-center"
      >
        <v-icon
          light
          class="custom-loader"
          :style="styleObject"
        >
          mdi-cached
        </v-icon>
        Carregando dados...
      </div>
      <div
        v-else-if="error"
        class="alert alert-danger"
      >
        {{ error }}
      </div>
      <div
        v-else
      >
        <v-container>
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <div
                id="idTable"
                style="overflow-x: auto;"
              >
                <table
                  style="width: 100%; color: black; border-collapse: collapse;"
                  class="elevation-1"
                  mobile-breakpoint="0"
                >
                  <thead>
                    <tr>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                        class="black--text title"
                      >
                        Nome reduzido
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                        class="black--text title"
                      >
                        Valor Aberto
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                        class="black--text title"
                      >
                        Valor Pago
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                        class="black--text title"
                      >
                        Dias vencido
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in dadosFornecedores"
                      :key="item.id"
                    >
                      <td
                        id="dadoMovimentacao"
                        style="text-align: left;"
                      >
                        {{ item.nome_reduzido }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                        :style="getColorAberto(item.vlr_aberto)"
                      >
                        {{ item.vlr_aberto }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                        :style="getColorPago(item.vlr_pago)"
                      >
                        {{ item.vlr_pago }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: center;"
                      >
                        {{ item.dias_vencido }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div><br>
              <router-link
                to="/contas-pagar/detalhe-ranking-fornecedores"
                :style="styleObject"
              >
                <div
                  id="linkDetalheFornecedores"
                  class="text-center"
                >
                  <v-icon
                    id="iconLinkFornecedores"
                    class="text-center"
                  >
                    mdi-chevron-double-down
                  </v-icon><br>
                  Detalhar
                </div>
              </router-link>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>
  </v-container>
</template>

<script>
  import ContasPagar from '../../../../../services/contaspagar'
  import eventEmit from '../../core/EventoEmit'

  export default {
    name: 'ShowDadosFornecedores',
    emits: [],
    components: {
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      styleObjectInadimplente: {
        color: '#f27686',
      },
      loading: false,
      error: null,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      headersFornecedores: [
        { text: 'Nome reduzido', value: 'nome_reduzido', class: 'black--text title' },
        { text: 'Valor Aberto', value: 'vlr_aberto', align: 'right', class: 'black--text title' },
        { text: 'Valor Pago', value: 'vlr_pago', align: 'right', class: 'black--text title' },
        { text: 'Dias vencido', value: 'dias_vencido', align: 'right', class: 'black--text title' },
      ],
      dadosFornecedores: [],
    }),

    created () {
      eventEmit.$on('set-dados-filtro', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('set-dados-filtro', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, ultimoDia, select) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = ultimoDia
        this.select = select

        this.showContasPagarValoresAFornecedores()
      },

      async showContasPagarValoresAFornecedores () {
        this.loading = true
        this.dadosFornecedores = []

        const empresaJson = JSON.stringify(this.select)

        localStorage.setItem('dataInicial', this.primeiroDia)
        localStorage.setItem('dataFinal', this.ultimoDia)
        localStorage.setItem('empresaId', empresaJson)

        await ContasPagar.showValoresAFornecedores(this.primeiroDia, this.ultimoDia, this.select, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.dadosFornecedores = resposta.data.dadosFornecedores.map((item) => {
              var listaDadosFornecedores = ({
                nome_reduzido: item.nome_reduzido,
                vlr_aberto: parseFloat(item.vlr_aberto).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                vlr_pago: parseFloat(item.vlr_pago).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                dias_vencido: parseFloat(item.dias_vencido),
              })

              return listaDadosFornecedores
            })
          } else if (resposta.data.msg === 'Não dados de valores a pagar para fornecedores no período selecionado') {
            this.dadosFornecedores = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },

      getColorPago (value) {
        return 'color: #4CAF50'
      },

      getColorAberto (value) {
        return 'color: red'
      },
    },
  }
</script>

<style scoped>
  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #projecaoReceberDias {
      font-size: 16px;
      display: grid;
      align-items: center;
      margin: 0.7rem 0 0 15rem;
      font-weight: bold;
    }

    #headersFornedores {
      width: 100%;
    }

    #idTable {
      max-height: 450px;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #projecaoReceberDias {
      font-size: 16px;
      display: grid;
      align-items: center;
      margin: 0.7rem 0 0 15rem;
      font-weight: bold;
    }

    #headersFornedores {
      width: 100%;
    }
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 445px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  #projecaoReceberDias {
    font-size: 16px;
    display: grid;
    align-items: center;
    margin: 0.7rem 0 0 -3.5rem;
    font-weight: bold;
  }
</style>
